module.exports = __webpack_public_path__ + "img/mhc-now-logo.deddc96b.png";